import { useRoutes, Navigate } from 'react-router-dom';
import { useKeycloakAuth } from '../contexts/KeycloakAuthProvider';
import { Layout } from '../components/Layout';
import AdminPage from '../pages/Admin/Admin';
import AuthPage from '../pages/Auth/AuthPage';
import AdminRoute from '../components/AdminRoute';
import { SettingsLayout } from '../components/SettingsLayout';

// Loading component
const LoadingScreen = () => (
  <div className='flex min-h-screen items-center justify-center bg-gray-50 dark:bg-dark-background'>
    <div className='text-center'>
      <div className='mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-b-2 border-blue-600'></div>
      <p className='text-gray-600 dark:text-dark-text-secondary'>Đang tải...</p>
    </div>
  </div>
);

// Protected Route Component
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { isSignedIn } = useKeycloakAuth();
  if (!isSignedIn) return <Navigate to='/auth' replace />;
  return <>{children}</>;
};

const Router = () => {
  const { isSignedIn, isInitialized } = useKeycloakAuth();

  const routes = [
    {
      path: '/',
      element: isSignedIn ? <Navigate to='/admin' replace /> : <Navigate to='/auth' replace />
    },
    {
      path: '/auth',
      element: isSignedIn ? <Navigate to='/admin' replace /> : <AuthPage />
    },
    {
      path: '/settings',
      element: (
        <ProtectedRoute>
          <Layout>
            <SettingsLayout />
          </Layout>
        </ProtectedRoute>
      )
    },
    {
      path: '/admin',
      element: (
        <AdminRoute>
          <Navigate to='/admin/agents' replace />
        </AdminRoute>
      )
    },
    {
      path: '/admin/agents',
      element: (
        <AdminRoute>
          <Layout>
            <AdminPage defaultTab='agents' />
          </Layout>
        </AdminRoute>
      )
    },
    {
      path: '/admin/users',
      element: (
        <AdminRoute>
          <Layout>
            <AdminPage defaultTab='users' />
          </Layout>
        </AdminRoute>
      )
    },
    {
      path: '/admin/documents',
      element: (
        <AdminRoute>
          <Layout>
            <AdminPage defaultTab='documents' />
          </Layout>
        </AdminRoute>
      )
    },
    {
      path: '/admin/knowledge-graph',
      element: (
        <AdminRoute>
          <Layout>
            <AdminPage defaultTab='knowledgeGraph' />
          </Layout>
        </AdminRoute>
      )
    },
    {
      path: '/admin/models',
      element: (
        <AdminRoute>
          <Layout>
            <AdminPage defaultTab='models' />
          </Layout>
        </AdminRoute>
      )
    },
    {
      path: '/admin/kg-build',
      element: (
        <AdminRoute>
          <Layout>
            <AdminPage defaultTab='knowledgeGraph' />
          </Layout>
        </AdminRoute>
      )
    },
    {
      path: '*',
      element: <div>404 - Trang không tồn tại</div>
    }
  ];

  const routeElement = useRoutes(routes);

  // Show loading screen while checking authentication
  if (!isInitialized) {
    return <LoadingScreen />;
  }

  return routeElement;
};

export default Router;
